/** @jsx jsx */ jsx;
import { jsx } from "@emotion/core";
import React from "react";
import { Provider } from "react-redux";
import manufacturingStore from "./manufacturingStore";
import TagRequest from "./TagRequest";
import { ITagRequestProps } from "./types";

class RequestWrapper extends React.Component<ITagRequestProps> {
    render() {
        return (
            <Provider store={manufacturingStore}>
                <TagRequest {...this.props} />
            </Provider>
        );
    }
}

export default RequestWrapper;
